import React, { useState } from 'react'
import Header from '../../../components/generals/header'
import stylesIndex from './../../../css/Index.module.css'
import store from '../../../reducer/store'
import styles from '../../../css/reports/Reports.module.css'
import { NavLink } from 'react-router-dom'
import { Button } from 'reactstrap'
import DataTableLazyDevices from '../../../components/generals/datatables/dataTableLazyDevices'
import { useTranslation } from 'react-i18next'

export default function DevicesReport () {
  const { t } = useTranslation('devicesReport')
  const { user } = store.getState()
  const role = user.roles

  const [columnsRole] = useState([
    ...role?.devicesPage.columDataTableDevices
  ])

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>
        <Header title={t('title')} />
        <div>
          <NavLink to="/mdm/reports">
              <Button variant="dark" className={styles.return_btn}>
                <i className="pi pi-arrow-circle-left" style={{ marginRight: '0.5rem' }}></i>
                {t('button')}
              </Button>
          </NavLink>
        </div>
        <div>
          <DataTableLazyDevices
            table="devicesReport"
            onSelecteds={null}
            selectedRows={null}
            groupId={false}
            updateSelected={false}
            exportsPdf={role?.reportsPage.exportPdfInReport}
            exportsCsv={role?.reportsPage.exportCsvInReport}
            rowSelecteds={false}
            clearSelection={false}
            actionDashboard={false}
            actionDelete={false}
            columnsRole={columnsRole}
            namePdf={t('namePdf')}
          />
        </div>
      </div>
    </div>
  )
}
